<div class="page-container">
    <div class="page-body-container">
        <div class="inner-content">
            <div class="card col-span-12">
                @if (profile) {
                    <div class="card-header-container border-b border-canna-primary mb-4">
                        <h1 class="card-header">Profil</h1>
                    </div>
                    <app-patient-profile-administration [profile]="profile"></app-patient-profile-administration>
                }
            </div>
        </div>
    </div>
</div>
